<!-- =========================================================================================
  File Name: projects.vue
  Description: All Projects list
  ----------------------------------------------------------------------------------------
  Item Name: KOZO Admin - VueJS Dashboard
  Author:
  Author URL:
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full">
        <router-link to="/apps/projects">
          <feather-icon icon="ArrowLeftCircleIcon" svgClasses="h-8 w-8" />
        </router-link>
      </div>

      <div class="vx-col w-full">
        <vs-tabs v-model="tabIndex">
          <vs-tab label="Contract View" icon-pack="feather" icon="icon-eye">
            <div class="tab-text">
              <!-- CONTRACT MASTER -->
              <div>
                <contract-master></contract-master>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Contract Form" icon-pack="feather" icon="icon-file">
            <!-- CONTARCT FORMS -->
            <div>
              <contract-all-form-view></contract-all-form-view>
            </div>
          </vs-tab>

          <vs-tab label="List View" icon-pack="feather" icon="icon-list">
            <!-- CONTRACT FORM LIST -->
            <div>
              <contract-form-list-view></contract-form-list-view>
            </div>
          </vs-tab>

          <vs-tab label="Chart View" icon-pack="feather" icon="icon-bar-chart-2">
            <!-- CONTRACT CHART VIEW -->
            <div>
              <contract-chart-view></contract-chart-view>
            </div>
          </vs-tab>

          <vs-tab label="Contract Status" icon-pack="feather" icon="icon-file-text">
            <!-- CONTRACT STATUS VIEW -->
            <div>
              <contract-filter></contract-filter>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import contractMaster from "@/views/apps/contract/contractMaster.vue";
import contractAllFormView from "@/views/apps/contract/contractAllFormView.vue";
import contractFormListView from "@/views/apps/contract/contractFormListView.vue";
import contractChartView from "@/views/apps/contract/contractChartView.vue";
import contractFilter from "@/views/apps/contract/contractFilter.vue";

export default {
  data() {
    return {
      isActive: false,
      analyticsData: "",
      isImp: false,
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      show: false,
      items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      nextNum: 10,
      tabIndex: 0,
    };
  },
  mounted() {
    eventBus.$on("switchFormEditTabView", (data) => {
      this.tabIndex = data.tabIndexView;
    });
  },
  methods: {
    myFilter: function () {
      this.isActive = !this.isActive;
    },
  },
  components: {
    contractMaster,
    contractAllFormView,
    contractFormListView,
    contractChartView,
    contractFilter,
  },
};
</script>

<style lang="scss">
#dashboard-analytics {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
.con-vs-tabs .con-ul-tabs,
.vs-tabs--ul {
  background-color: #fff !important;
}

.theme-dark .con-vs-tabs .theme-dark .con-ul-tabs,
.theme-dark .vs-tabs--ul {
  background-color: #10163a !important;
  -webkit-box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.5);
}

.theme-dark .con-vs-tabs .theme-dark .con-ul-tabs,
.theme-dark .vs-tabs--ul span {
  color: #c2c6dc;
  font-weight: bold;
}
</style>
